// extracted by mini-css-extract-plugin
module.exports = {"module":"Banner_module__3Q4ou","cancellable":"Banner_cancellable__1GKw3","closeIcon":"Banner_closeIcon__37Z2b","golden":"Banner_golden__1hxd3"};